export const QUANTITY_DISCOUNT_VALUE = 15;
export const CATALOG_BANNER_KEY = 'catalog_banner_show';
export const CART_BANNER_KEY = 'cart_banner_show';
export const CART_DIALOG_KEY = 'cart_dialog_show';
